{
  "tabs": {
    "title": "Volunteering",
    "teams": "Teams",
    "trainingModules": "Training Modules"
  },
  "teams": {
    "heading": "Teams",
    "newTeam": "New Team",
    "emptyTitle": "No Teams Yet",
    "emptyMessage": "Create a volunteer team to get started."
  },
  "team": {
    "loadFailedTitle": "Unable to Load Team",
    "loadFailedMessage": "This team may have been deleted.",
    "backToTeams": "Back to Teams",
    "noMembers": "No volunteers on this team. Invite a volunteer to get started.",
    "viewAll_one": "View all {{count}} volunteer",
    "viewAll_other": "View all {{count}} volunteers",
    "roles": "Roles",
    "editTeam": "Edit Team",
    "inviteVolunteer": "Invite Volunteer",
    "unknownPerson": "Unknown"
  },
  "menu": {
    "details": "Details",
    "editRoles": "Edit Roles",
    "assignedTraining": "Assigned Training",
    "removeFromTeam": "Remove from Team"
  },
  "rolePicker": {
    "label": "Roles"
  },
  "errors": {
    "loadTeams": "Failed to load teams.",
    "loadTeam": "Failed to load this team.",
    "loadTrainingModules": "Failed to load Training Modules.",
    "loadTrainingModule": "Failed to load this Training Module.",
    "loadAssignedTraining": "Failed to load assigned training.",
    "missingChurch": "Missing church context. Please refresh and try again."
  },
  "common": {
    "close": "Close",
    "save": "Save",
    "saving": "Saving…",
    "done": "Done",
    "cancel": "Cancel",
    "tryAgain": "Try Again",
    "back": "Back",
    "loading": "Loading…"
  }
}
